import {Component, NgModule, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";

import {TranslateModule, TranslateService} from "@ngx-translate/core";

import {LottieModule} from "ngx-lottie";

import {ButtonModule} from "primeng/button";

import {DownloadModule} from "./download/download.component";
import {playerFactory} from "../../shared/factory/player-factory";
import {AnimationService} from "../../shared/service/animation.service";

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {

  animationData: any;

  constructor(
    private translateService: TranslateService,
    private animationService: AnimationService
  ) {
  }

  ngOnInit(): void {
    this.loadAnimation();
  }

  loadAnimation() {
    this.animationService.loadAnimation('/assets/animations/feedback-with-dynamic-text.json').subscribe((data: any) => {
      this.animationData = this.editAnimation(data);
    });
  }

  editAnimation(animation: any) {
    animation.assets[2].layers[1].t.d.k[0].s.t = this.translateService.instant('app.download.feedback');
    animation.assets[2].layers[2].t.d.k[0].s.t = this.translateService.instant('app.download.feedback');
    return animation;
  }

  redirectToFrequentlyAskedQuestions() {
    window.location.href = 'https://www.motorola.com/moto-ai';
  }

}

@NgModule({
  imports: [
    CommonModule,
    DownloadModule,
    TranslateModule,
    RouterModule,
    ButtonModule,
    LottieModule.forRoot({player: playerFactory})
  ],
  declarations: [InformationComponent],
  exports: [InformationComponent]
})
export class InformationModule {
}
